import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { useTutorial } from '../contexts/TutorialContext';
import { Button } from './ui/button';
import { getDisplayName } from '../lib/displayName';

export default function WelcomeTutorialModal() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { progress, setTourState, setBulk } = useTutorial();

  const show = !!user && user.role === 'client' && progress?.welcome?.state === 'pending';
  if (!show) return null;

  const firstName = getDisplayName(user?.name);

  const onGotIt = () => {
    // Hand off to the navigation spotlight tour. It is queued here rather than
    // defaulting to pending so it can never render underneath this modal.
    setBulk([
      { tour_id: 'welcome',     state: 'completed' },
      { tour_id: 'welcome_nav', state: 'pending' },
    ]);
  };

  const onSkipAll = () => {
    setBulk([
      { tour_id: 'welcome',     state: 'dismissed' },
      { tour_id: 'welcome_nav', state: 'dismissed' },
      { tour_id: 'workouts',    state: 'dismissed' },
      { tour_id: 'live_workout', state: 'dismissed' },
      { tour_id: 'diet',        state: 'dismissed' },
      { tour_id: 'check_ins',   state: 'dismissed' },
    ]);
  };

  return (
    <div className="fixed inset-0 z-[85] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="bg-gradient-to-br from-zinc-900 to-zinc-950 border border-zinc-800 rounded-2xl shadow-2xl p-6 max-w-md w-full">
        <div className="text-2xl font-semibold text-white mb-3">
          {t('tour.welcome.title', { name: firstName })}
        </div>
        <div className="text-sm text-zinc-300 mb-6 leading-relaxed">
          {t('tour.welcome.body')}
        </div>
        <div className="flex flex-col gap-2">
          <Button onClick={onGotIt} className="bg-orange-500 hover:bg-orange-600 text-white">
            {t('tour.welcome.gotIt')}
          </Button>
          <button onClick={onSkipAll} className="text-xs text-zinc-500 hover:text-zinc-300 underline">
            {t('tour.welcome.skipAll')}
          </button>
        </div>
      </div>
    </div>
  );
}
